import CustomCarrusel from "@components/custom-carrusel";
import React from "react";
import Link from "next/link";
import { CPagesPath } from "shared/models/const/pages-path";
import { useTranslations } from "next-intl";
import { Typography, Grid, Box, Card, CardContent } from "@mui/material";
import { styled } from "@mui/material/styles";
import WsSectionTitleWithThinTitle from "@components/a1-refactor/typography/WsSectionTitleWithThinTitle copy";

const CitiesSection = styled(Grid)(({ theme }) => ({
  width: "100%",
  minHeight: "50vh",
  backgroundColor: "#fff",
  padding: "5rem 4rem",

  "@media screen and (max-width: 768px)": {
    padding: "2rem 1rem",
  },
}));

const CityCard = styled(Card)(({ theme }) => ({
  maxWidth: 300,
  display: "inline-block",
  margin: "0 10px 10px",
  boxShadow: "none",
  backgroundColor: "transparent",
  textAlign: "center",
  textDecoration: "none",
  "& a": {
    textDecoration: "none",
  },
}));

const CityImage = styled("img")({
  maxWidth: 135,
  width: "100%",
  height: 135,
  backgroundPosition: "center",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  borderRadius: "50%",
  marginBottom: 10,
});

const CityTitle = styled(Typography)({
  color: "#808080",
  fontWeight: 500,
  fontSize: "15.6px !important",
});

const ContentCities = styled(Box)({
  display: "flex !important",
  justifyContent: "center",
});

function CitiesHomeSection() {
  const translation = useTranslations("home.cities");

  const citiesTitles = translation("title");

  const [title, ...rest] = citiesTitles.split(" ");

  return (
    <CitiesSection container rowGap={4}>
      <Grid item xs={12}>
        <WsSectionTitleWithThinTitle title={title} subtitle={rest.join(" ")} />
      </Grid>
      <Grid item xs={12} position="relative">
        <CustomCarrusel>
          {cities.map((city, i) => (
            <ContentCities key={i}>
              <Link href={city.link} passHref>
                <Box component="a" sx={{ textDecoration: "none" }}>
                  <CityCard>
                    <CardContent sx={{ padding: 0 }}>
                      <CityImage src={city.image} alt={city.label} />
                      <CityTitle variant="h6">{city.label}</CityTitle>
                    </CardContent>
                  </CityCard>
                </Box>
              </Link>
            </ContentCities>
          ))}
        </CustomCarrusel>
      </Grid>
    </CitiesSection>
  );
}

export default CitiesHomeSection;

const cities = [
  {
    label: "La Romana",
    image: "/images/la_romana_remax_rd.png",
    link:
      CPagesPath.es.properties +
      `?businessTypes=sale&currencyType=us&locations[]=id-60%26description-LA%20ROMANA%26`,
  },
  {
    label: "Punta Cana",
    image: "/images/punta_cana_remax_rd.png",
    link:
      CPagesPath.es.properties +
      `?businessTypes=sale&currencyType=us&locations[]=id-434%26description-PUNTA%20CANA%26`,
  },
  {
    label: "Santo Domingo",
    image: "/images/santo_domingo_remax_rd.png",
    link:
      CPagesPath.es.properties +
      `?businessTypes=sale&currencyType=us&locations[]=id-1%26description-SANTO%20DOMINGO%20DE%20GUZMÁN%26`,
  },
  {
    label: "Samaná",
    image: "/images/samana_remax_rd.png",
    link:
      CPagesPath.es.properties +
      `?businessTypes=sale&currencyType=us&locations[]=id-93%26description-SAMANÁ%26`,
  },
  {
    label: "Santiago",
    image: "/images/santiago_remax_rd.png",
    link:
      CPagesPath.es.properties +
      `?businessTypes=sale&currencyType=us&locations[]=id-120%26description-SANTIAGO%26`,
  },
  {
    label: "Puerto Plata",
    image: "/images/puerto_plata_remax_rd.png",
    link:
      CPagesPath.es.properties +
      `?businessTypes=sale&currencyType=us&locations[]=id-81%26description-PUERTO%20PLATA%26`,
  },
];
